// src/services/adminService.js
import axiosInstance from '../axiosConfig';

const getUsers = () => axiosInstance.get('/api/admin/users');

const createUser = (payload) => axiosInstance.post('/api/admin/users', payload);

const updateUser = (userId, payload) => axiosInstance.put(`/api/admin/users/${userId}`, payload);

const getStats = () => axiosInstance.get('/api/admin/stats');

const updateRegistration = (registrationOpen) =>
  axiosInstance.put('/api/admin/settings/registration', { registrationOpen });

const getCards = () => axiosInstance.get('/api/admin/cards');

const adminService = {
  getUsers,
  createUser,
  updateUser,
  getStats,
  updateRegistration,
  getCards
};

export default adminService;
